import React from "react";
import {
  AiFillFacebook,
  AiFillInstagram,
  AiFillYoutube,
  AiOutlineTwitter,
} from "react-icons/ai";
import {
  footerCompanyLinks,
  footerProductLinks,
  footerSupportLinks,
} from "../../static/data";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <div className="bg-[#152942] text-white">
      <div className="md:flex md:justify-between md:items-center sm:px-12 px-4 bg-[#40B884] py-7">
        <h1 className="lg:text-4xl text-3xl md:mb-0 mb-6 lg:leading-normal font-semibold md:w-2/5">
          <span className="text-[#152942]">Subscribe us</span>
          <br />
          <span>now to get news</span>
          <br /> events and offers
        </h1>
        <div className="flex items-center w-full md:w-auto">
          <input
            type="text"
            required
            placeholder="Enter your email..."
            className="text-[#152942] sm:w-72 w-full sm:mr-5 mr-1 lg:mb-0 mb-4 rounded px-4 py-2 focus:outline-none"
          />
          <button className="bg-[#152942] hover:bg-[#40B884] duration-300 px-5 py-3 rounded-md text-white md:w-auto w-full">
            Submit
          </button>
        </div>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-4 gap-6 sm:px-8 px-5 py-16 sm:text-center">
        <ul className="px-5 text-center sm:text-start flex sm:block flex-col items-center">
          <h1 className="text-[30px] font-[600] font-Poppins tracking-wider">
            OmniMart
          </h1>
          <br />
          <p>The home and elements needed to create beautiful products.</p>
          <div className="flex items-center mt-[15px] text-[#40B884] gap-2">
            <AiFillFacebook size={25} className="cursor-pointer" />
            <AiOutlineTwitter size={25} style={{ cursor: "pointer" }} />
            <AiFillInstagram size={25} style={{ cursor: "pointer" }} />
            <AiFillYoutube size={25} style={{ cursor: "pointer" }} />
          </div>
        </ul>
        <ul className="text-center sm:text-start">
          <h1 className="mb-1 font-semibold">Shop</h1>
          {footerProductLinks.map((link) => (
            <li key={link.name}>
              <Link
                className="text-gray-400 hover:text-[#40B884] duration-300 text-sm cursor-pointer leading-6"
                to={link.link}
              >
                {link.name}
              </Link>
            </li>
          ))}
        </ul>
        <ul className="text-center sm:text-start">
          <h1 className="mb-1 font-semibold">Company </h1>
          {footerCompanyLinks.map((link) => (
            <li key={link.name}>
              <Link
                className="text-gray-400 hover:text-[#40B884] duration-300 text-sm cursor-pointer leading-6"
                to={link.link}
              >
                {link.name}
              </Link>
            </li>
          ))}
        </ul>
        <ul className="text-center sm:text-start">
          <h1 className="mb-1 font-semibold">Support</h1>
          {footerSupportLinks.map((link) => (
            <li key={link.name}>
              <Link
                className="text-gray-400 hover:text-[#40B884] duration-300 text-sm cursor-pointer leading-6"
                to={link.link}
              >
                {link.name}
              </Link>
            </li>
          ))}
        </ul>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10 text-center pt-2 text-gray-400 text-sm pb-8">
        <span>© 2025 Eshop. All rights reserved.</span>
        <span>Terms - Privacy Policy</span>
        <div className="sm:block flex items-center justify-center w-full">
          <img
            src="https://hamart-shop.vercel.app/_next/image?url=%2F_next%2Fstatic%2Fmedia%2Ffooter-payment.a37c49ac.png&w=640&q=75"
            alt="payment-cards"
          />
        </div>
      </div>
    </div>
  );
};

export default Footer;
